// import axios from "axios";
// import { useEffect, useState } from "react";

// const API_KEY = process.env.REACT_APP_GIPHY_API_KEY;

// export default function Random() {
//   const [gif, setGif] = useState("");

//   const fetchRandomGif = async () => {
//     const url = `https://api.giphy.com/v1/gifs/random?api_key=${API_KEY}`;
//     const response = await axios.get(url);
//     const data = response.data;

//     const image = data.data.images.downsized_large.url;
//     console.log(image);
//     setGif(image);
//   };
//   useEffect(() => {
//     fetchRandomGif();
//   }, []);

//   const handleClick = () => {
//     fetchRandomGif();
//   };

//   return (
//     <div className="flex flex-col gap-4 py-4 justify-center items-center w-full lg:w-1/2 overflow-hidden aspect-auto bg-green-400 border-2 border-gray-500 rounded-2xl">
//       <h1 className="uppercase underline font-bold md:text-2xl text-xl text-center">A Random GIF</h1>
//       <img src={gif} alt="Random GIF" className="max-w-[30rem] px-4 object-contain" />
//       <button
//         className="uppercase w-4/5 py-2 bg-white/70 rounded-lg my-2 hover:bg-white transition-all font-semibold text-center"
//         onClick={handleClick}>
//         Generate
//       </button>
//     </div>
//   );
// }

import useGif from "../hooks/useGif";

export default function Tag() {
  const { gif, loading, fetchRandomGif } = useGif();

  return (
    <div className="flex flex-col gap-4 py-4 justify-center items-center w-full lg:w-1/2 overflow-hidden aspect-auto bg-green-400 border-2 border-gray-500 rounded-2xl">
      <h1 className="uppercase underline font-bold md:text-2xl text-xl text-center">A Random GIF</h1>
      {loading ? (
        <div className="spinner"></div>
      ) : (
        <img src={gif} alt="Random GIF" className="max-w-[30rem] px-4 object-contain" />
      )}
      <button
        className="uppercase w-4/5 py-2 bg-white/70 rounded-lg my-2 hover:bg-white transition-all font-semibold text-center"
        onClick={() => fetchRandomGif()}>
        Generate
      </button>
    </div>
  );
}
